<template>
  <div class="detail-header-container rounded-[10px] bg-white">
    <div class="flex justify-between p-20 pb-0">
      <div class="w-950">
        <div class="mb-15 flex">
          <div class="item-img header-img relative mr-20 flex h-197 w-285 items-center justify-center rounded-[10px]">
            <img :src="detail.imageUrl" alt="" />
            <div class="absolute bottom-0 right-0 cursor-pointer rounded-br-[10px] rounded-tl-[10px] bg-black/30 px-10 py-5" @click="itemTrackerVisible = true">
              <i class="iconfont icon-chakanhuanshou text-white"></i>
            </div>
          </div>
          <div>
            <el-tooltip :content="$t('点击复制名称')" placement="top" effect="dark">
              <!-- content to trigger tooltip here -->
              <div class="mb-10 cursor-pointer text-26 font-semibold" @click="copyName">{{ detail.shortName }}</div>
            </el-tooltip>

            <div class="mb-20">
              <span class="mr-20" :style="{ color: detail.exteriorColor }">{{ detail.exteriorName }}</span>
              <span class="mr-20" :style="{ color: detail.rarityColor }">{{ detail.rarityName }}</span>
              <span v-if="detail.qualityColor != '#888888'" class="mr-20" :style="{ color: detail.qualityColor }">{{ detail.qualityName }}</span>
            </div>
            <div class="mb-10 leading-none">
              <span class="mr-20 text-28 font-semibold" :class="detail.lowestPrice ? 'text-color-orange' : 'text-color-gray'">
                <span v-if="detail.lowestPrice">{{ monetaryUnit() }}{{ currencyTransform(detail.lowestPrice) }}</span>
                <span v-else>{{ $t('暂无在售信息') }}</span>
              </span>
              <span v-if="detail.diff1Day !== null" class="text-14" :class="[detail.diff1Day < 0 ? 'text-color-green' : 'text-color-red']"
                >{{ detail.diff1Day > 0 ? '+' : '' }} {{ detail.diff1Day }} %</span
              >
            </div>
            <div class="mb-10 flex items-center">
              <div
                class="mr-10 inline-block rounded-[15px] px-10 py-5"
                :style="{ backgroundColor: hexToRgba(detail.analysisTags.find(item => item.type === 'Update_Level').background, 0.1) }"
                v-html="detail.analysisTags.find(item => item.type === 'Update_Level').style"
              ></div>
              <div v-if="platformExpectList?.length > 0" class="">
                <targetTips :row="detail" :folder-id="folderId">
                  <template #base>
                    <div v-if="reachExpect" class="flex h-31 cursor-pointer items-center justify-center rounded-[20px] bg-[#F87600] px-5 text-white">
                      {{ $t('已达预期') }}
                    </div>
                    <div v-else class="flex h-28 cursor-pointer items-center justify-center rounded-[20px] bg-gray-light px-5 text-white">{{ $t('未达预期') }}</div>
                  </template>
                </targetTips>
              </div>
            </div>
            <div class="text-color-lightgray">{{ $t('更新时间') }}：{{ dayjs(detail.updateTime * 1000).format('MM-DD HH:mm:ss') }}</div>
          </div>
        </div>
        <div class="category-list flex">
          <NuxtLink v-for="relate of categoryInfo.relatedList" :key="relate.itemId" :href="`/cs2/${relate.marketHashName}`">
            <div class="category-item mr-15 pt-10" :class="{ active: relate.itemId === detail.itemId }">
              <div>{{ relate.tag }}</div>
              <div>{{ monetaryUnit() }}{{ currencyTransform(relate.sellPrice) }}</div>
            </div>
          </NuxtLink>

          <NuxtLink v-for="category of categoryInfo.categoryList" :key="category.itemId" :href="`/cs2/${category.marketHashName}`">
            <div v-if="category.itemId !== detail.itemId" class="category-item mr-15 pt-10">
              <div><i class="iconfont icon-xingzhuang text-16"></i>{{ category.tag }}</div>
              <div>{{ monetaryUnit() }}{{ currencyTransform(category.sellPrice) }}</div>
            </div>
          </NuxtLink>
        </div>
      </div>
      <el-divider direction="vertical" style="height: 215px; margin-top: 50px" />
      <div class="w-386 p-10 pb-0">
        <div class="flex justify-end">
          <div v-if="selfDetail?.isCollect" class="flex cursor-pointer items-center" @click="switchCollectItem(detail.id)">
            <i class="iconfont icon-yishoucang text-color-primary text-26"></i>
            <span class="test-14 text-color-gray ml-6">{{ $t('取消收藏') }}</span>
          </div>
          <div v-else class="mb-10 flex cursor-pointer items-center" @click="switchCollectItem(detail.id)">
            <i class="iconfont icon-shoucang text-color-gray text-26"></i>
            <span class="test-14 text-color-gray ml-6">{{ $t('收藏') }}</span>
          </div>
        </div>
        <div class="text-color-gray mb-20">{{ $t('概况') }}</div>
        <div class="relative flex h-180 w-350 items-center">
          <div class="tags-container h-full w-full overflow-hidden">
            <div v-for="(tag, index) in danmuList" :key="index" class="h-32">
              <div
                v-if="tag.tagInfo.background"
                class="tag-item relative mb-5 rounded-[15px] px-10 py-5"
                :style="{ backgroundColor: hexToRgba(tag.tagInfo.background, 0.1) }"
                v-html="tag.tagInfo.style"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-divider style="margin-top: 15px; margin-bottom: 0" />
    <div class="text-color-gray flex h-50 pl-20">
      <div class="mr-50 flex items-center">
        {{ $t('存世量') }}: <span class="mx-5 text-black"> {{ detail.surviveNum }}</span>
        <mytooltip placement="bottom" :content="$t('STEAMDT采集到饰品，通过磨损、类型等计算出唯一指纹，一个指纹对应一个存世量')"
          ><i class="iconfont icon-changjianwenti ml-5"></i
        ></mytooltip>
      </div>
      <div class="mr-50 flex items-center">
        {{ $t('今日推算成交') }}: <span class="mx-5 text-black">{{ detail.transactionCount }}</span>
        <!--        <mytooltip placement="bottom" :content="$t('各平台成交数据')"><i class="iconfont icon-changjianwenti ml-5"></i></mytooltip>-->

        <mytooltip :class="'w-370'" placement="bottom">
          <i class="iconfont icon-changjianwenti ml-5"></i>
          <template #content>
            <div class="py-15 text-14 text-gray-light">
              <p>
                {{
                  $t(
                    '成交数据获得方式：SteamDT成交非爬取三方成交数据，而是通过三方平台在售数据，得到磨损、类型等计算得出指纹，通过指纹查询出对应Steam库存，通过结合Steam库存等数据判断成交。'
                  )
                }}
              </p>
              <br />
              <p>{{ $t('问：为什么成交的数量和实际对不上？') }}</p>
              <p>
                {{
                  $t(
                    '答：1. Steam规则新交易的饰品10天内不可见。 2.对应的卖家Steam不在SteamDT的Steam账号库中(Steam账号并非用户在SteamDT上进行绑定，而是通过Steam提供的相关数据进行)。3. 非底价货。4.求购出货 5. 无磨损饰品。'
                  )
                }}
              </p>
              <br />
              <p>{{ $t('问：为何和竞品成交数据相差巨大') }}</p>
              <p>{{ $t('答：得益于SteamDT拥有指纹相关能力，每件成交都可以追踪到其饰品其Steam库存。竞品多数采用在售数增减的方式计算成交。') }}</p>
            </div>
          </template>
        </mytooltip>
      </div>
      <div class="mr-50 flex items-center">
        {{ $t('挂刀/搬砖') }}: <span class="mx-5 text-black">{{ detail.consignmentBest }}/{{ detail.cashRatio }}</span>
        <mytooltip placement="bottom"
          ><i class="iconfont icon-changjianwenti ml-5"></i>
          <template #content>
            <div class="py-15 text-14 text-gray-light">
              <p>{{ $t('比例越低越好') }}</p>
              <p>{{ $t('Steam挂刀 = 平台最低价 / (Steam在售价 * 0.869)') }}</p>
              <p>{{ $t('Steam套现 = Steam价格 / (平台最低价 - (平台最低价 * 手续费))') }}</p>
            </div>
          </template>
        </mytooltip>
      </div>
      <!-- <div class="mr-50 flex items-center">
        {{ $t('换手率') }}: <span class="mx-5 text-black">{{ detail.turnoverRate }}</span>
        <mytooltip placement="bottom" :content="$t('换手率 = 成交量 / 存世量')"><i class="iconfont icon-changjianwenti ml-5"></i></mytooltip>
      </div> -->
    </div>
    <el-dialog v-model="itemTrackerVisible" class="item-tracker-dialog" destory-on-close :show-close="false" width="1010">
      <template #header="{ close, titleId, titleClass }">
        <div class="my-header mb-10 h-30">
          <div class="mb-8 flex justify-end pr-15 pt-15">
            <i class="iconfont icon-guanbi1 cursor-pointer font-semibold text-gray" @click="close"></i>
          </div>
          <div class="text-center">
            <div class="text-22 font-semibold text-black">{{ $t('所属武器箱') }}</div>
          </div>
        </div>
      </template>
      <template #default>
        <div class="min-h-600">
          <itemTracker :market-hash-name="detail.marketHashName" :item-id="detail.itemId"></itemTracker>
        </div>
      </template>
    </el-dialog>
    <addCollect :id="detail.itemId" :visible="addCollectVisible" :type="'skin'" @close="closeAddCollcet"></addCollect>
  </div>
</template>
<script setup>
import dayjs from 'dayjs'
import mytooltip from '~/components/common/mytooltip.vue'
import { copy } from '#imports'
import itemTracker from './item-tracker.vue'
import addCollect from '~/pages/my/collect/components/add-collect.vue'
import { getCollectExpect } from '~~/api/collect'
import targetTips from '~/pages/my/collect/components/detail-target-tips.vue'

const props = defineProps({
  detail: {
    type: Object,
    default: function () {
      return {}
    }
  },
  categoryInfo: {
    type: Object,
    default: function () {
      return {}
    }
  }
})

let myinterval = null

const selfDetail = ref(props.detail)

const itemTrackerVisible = ref(false)

const addCollectVisible = ref(false)
const platformExpectList = ref([])
const danmuList = ref([
  {
    tagInfo: {},
    createTime: 0
  },
  {
    tagInfo: {},
    createTime: 0
  },
  {
    tagInfo: {},
    createTime: 0
  },
  {
    tagInfo: {},
    createTime: 0
  },
  {
    tagInfo: {},
    createTime: 0
  }
])

const reachExpect = ref(null)
onMounted(() => {
  setTimeout(() => {
    checkdanmu()
  }, 300)
  myinterval = setInterval(() => {
    checkdanmu()
  }, 300)
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      clearInterval(myinterval)
    } else {
      myinterval = setInterval(() => {
        checkdanmu()
      }, 300)
    }
  })
  getCollectExpectList()
})
function checkdanmu() {
  for (let i = 0; i < props.detail.analysisTags.length; i++) {
    const tag = props.detail.analysisTags[i]
    if (!tag.loaded) {
      senddanmu(tag)
      break
    }
  }
}
function senddanmu(tag) {
  tag.loaded = true

  let emptyIndexList = []
  for (let i = 0; i < danmuList.value.length; i++) {
    if (danmuList.value[i].createTime === 0) {
      emptyIndexList.push(i)
    }
  }
  const index = emptyIndexList[Math.floor(Math.random() * emptyIndexList.length)]
  danmuList.value[index] = {
    tagInfo: tag,
    createTime: new Date().getTime()
  }
  setTimeout(() => {
    tag.loaded = false
  }, 2500)
  setTimeout(() => {
    danmuList.value[index] = {
      tagInfo: {},
      createTime: 0
    }
  }, 5000)
}

function copyName() {
  copy(props.detail?.name)
  myMessage({ message: '复制成功', type: 'success' })
}

const getCollectExpectList = async () => {
  const res = await getCollectExpect({ itemId: props.detail.itemId })
  if (res.success) {
    platformExpectList.value = res.data
    for (const item of platformExpectList.value) {
      if (reachExpect.value) {
        break
      }
      if (item.expectUpdown === true) {
        if (item.sellPrice >= item.expectPrice) {
          reachExpect.value = true
        }
      }
      if (item.expectUpdown === false) {
        if (item.sellPrice <= item.expectPrice) {
          reachExpect.value = true
        }
      }
    }
  }
}

const closeAddCollcet = added => {
  addCollectVisible.value = false
  selfDetail.value.isCollect = added
}
function hexToRgba(hex, alpha) {
  let r = 0,
    g = 0,
    b = 0
  // 3 digits
  if (hex.length == 4) {
    r = parseInt(hex[1] + hex[1], 16)
    g = parseInt(hex[2] + hex[2], 16)
    b = parseInt(hex[3] + hex[3], 16)
  }
  // 6 digits
  else if (hex.length == 7) {
    r = parseInt(hex[1] + hex[2], 16)
    g = parseInt(hex[3] + hex[4], 16)
    b = parseInt(hex[5] + hex[6], 16)
  }
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
function switchCollectItem(id) {
  addCollectVisible.value = true
}
</script>
<style lang="scss" scoped>
.header-img {
  width: 276px;
  height: 187px;
  background: url(~/assets/images/detail/header-bg.png) center no-repeat;
  background-size: cover;
  img {
    max-width: 213px;
    max-height: 160px;
  }
}
.category-list {
  .category-item {
    width: 143px;
    height: 60px;
    text-align: center;
    border: 1px solid #dddfe7;
    border-radius: 10px;
    color: #777;
    &.active {
      color: #0252d9;
      border-color: #0252d9;
    }
  }
}
.tags-container {
  .tag-item {
    display: inline-block;
    animation: marquee 5s linear infinite; /* 跑马灯动画 */
  }
}
@keyframes marquee {
  0% {
    left: 100%;
  }
  100% {
    left: -40%;
  }
}
</style>

<style lang="scss">
.item-tracker-dialog {
  padding: 0;
  border-radius: 10px;
  overflow: hidden;
  .my-header {
    width: 1010px;
    height: 80px;
    background: url(~/assets/images/detail/dialog-bg.png) top no-repeat;
    background-size: 1010px 80px;
  }
  .el-dialog__header {
    padding-bottom: 0;
  }
}
</style>
